import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Group, Text, Box, Divider, TextInput, useMantineTheme } from '@mantine/core';
import { IconTrash, IconPlus } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { regexNumberOnly, safeValue, numberWithComma } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import ActionIconComponent from "../../components/general/ActionIconComponent";
import PaperWrapper from "../../components/utilities/PaperWrapper";
import InputComponent from "../../components/general/InputComponent";

const StepSelesaiTambahanJasa = ({ stateData, fnOnChange }) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();
    const theme = useMantineTheme();

    const notificationId = React.useRef({
        errorUbahHarga: 'stepSelesaiTambahanJasa-2',
        errorAddJasa: 'stepSelesaiTambahanJasa-3',
        errorEditJasa: 'stepSelesaiTambahanJasa-4',
        errorDeleteJasa: 'stepSelesaiTambahanJasa-5',
    })

    const [data, setData] = React.useState({
        jasa: {
            modalShow: false,
            harga: '',
            hargaError: '',

            qty: '',
            qtyError: '',

            nama: '',
            namaError: '',

            submitLoading: false
        },

        jasaEdit: {
            modalShow: false,

            id: '',

            nama: '',
            namaError: '',

            qty: '',
            qtyError: '',

            harga: '',
            hargaError: '',

            submitLoading: false
        },

        jasaDelete: {
            modalShow: false,
            id: '',
            nama: '',
            submitLoading: false
        },

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitDataTambahanJasa = () => {
        setData(d => ({ ...d, jasa: { ...d.jasa, namaError: '', qtyError: '', hargaError: '' } }));

        if (validator.isEmpty(data.jasa.nama, { ignore_whitespace: true })) {
            setData(d => ({ ...d, jasa: { ...d.jasa, namaError: 'Isi nama jasa terlebih dahulu.' } }));
        } else if (parseInt(Number(data.jasa.qty)) <= 0) {
            setData(d => ({ ...d, jasa: { ...d.jasa, qtyError: 'Jumlah item wajib diisi.' } }));
        } else if (parseInt(Number(data.jasa.harga)) <= 0) {
            setData(d => ({ ...d, jasa: { ...d.jasa, hargaError: 'Harga item wajib diisi.' } }));
        } else {
            setData(d => ({ ...d, jasa: { ...d.jasa, submitLoading: true } }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('project_id', stateData.projectId);
            formDT.append('project_process', stateData.projectProcess);
            formDT.append('project_is_cancel', stateData.projectIsCancel);

            formDT.append('jasa_nama', data.jasa.nama);
            formDT.append('jasa_qty', data.jasa.qty);
            formDT.append('jasa_harga', data.jasa.harga);

            axios({
                method: 'post',
                url: BE_API_TWO + '/add_tambahan_jasa',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, jasa: { ...d.jasa, submitLoading: false, modalShow: false } }));

                if (response.data.flag_status === 'isset') {
                    fnOnChange(response.data.data);

                    setData(d => ({ ...d, jasa: { ...d.jasa, nama: '', qty: '', harga: '' } }));
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorAddJasa,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, jasa: { ...d.jasa, submitLoading: false, modalShow: false } }));

                notifications.show({
                    id: notificationId.current.errorAddJasa,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }

    const submitDataTambahanJasaUpdate = () => {
        setData(d => ({ ...d, jasaEdit: { ...d.jasaEdit, namaError: '', qtyError: '', hargaError: '' } }));

        if (validator.isEmpty(data.jasaEdit.nama, { ignore_whitespace: true })) {
            setData(d => ({ ...d, jasaEdit: { ...d.jasaEdit, namaError: 'Isi nama jasaEdit terlebih dahulu.' } }));
        } else if (parseInt(Number(data.jasaEdit.qty)) <= 0) {
            setData(d => ({ ...d, jasaEdit: { ...d.jasaEdit, qtyError: 'Jumlah item wajib diisi.' } }));
        } else if (parseInt(Number(data.jasaEdit.harga)) <= 0) {
            setData(d => ({ ...d, jasaEdit: { ...d.jasaEdit, hargaError: 'Harga item wajib diisi.' } }));
        } else {
            setData(d => ({ ...d, jasaEdit: { ...d.jasaEdit, submitLoading: true } }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('project_id', stateData.projectId);
            formDT.append('project_process', stateData.projectProcess);
            formDT.append('project_is_cancel', stateData.projectIsCancel);

            formDT.append('jasa_id', data.jasaEdit.id);
            formDT.append('jasa_nama', data.jasaEdit.nama);
            formDT.append('jasa_qty', data.jasaEdit.qty);
            formDT.append('jasa_harga', data.jasaEdit.harga);

            axios({
                method: 'post',
                url: BE_API_TWO + '/update_tambahan_jasa',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, jasaEdit: { ...d.jasaEdit, submitLoading: false, modalShow: false } }));

                if (response.data.flag_status === 'isset') {
                    fnOnChange(response.data.data);

                    setData(d => ({ ...d, jasaEdit: { ...d.jasaEdit, nama: '', qty: '', harga: '', id: '' } }));
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorEditJasa,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, jasaEdit: { ...d.jasaEdit, submitLoading: false, modalShow: false } }));

                notifications.show({
                    id: notificationId.current.errorEditJasa,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }

    const submitDataTambahanJasaDelete = () => {
        setData(d => ({ ...d, jasaDelete: { ...d.jasaDelete, submitLoading: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);

        formDT.append('jasa_id', data.jasaDelete.id);

        axios({
            method: 'post',
            url: BE_API_TWO + '/delete_tambahan_jasa',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, jasaDelete: { ...d.jasaDelete, submitLoading: false, modalShow: false } }));

            if (response.data.flag_status === 'isset') {
                fnOnChange(response.data.data);

                setData(d => ({ ...d, jasaDelete: { ...d.jasaDelete, nama: '', id: '' } }));
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorDeleteJasa,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, jasaDelete: { ...d.jasaDelete, submitLoading: false, modalShow: false } }));

            notifications.show({
                id: notificationId.current.errorDeleteJasa,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const AllErrorBox = ({ stateArray = [] }) => {
        return (
            Object.keys(stateArray).map(key => {
                return (
                    <Text
                        key={key}
                        c={theme.colorScheme === 'light' ? theme.colors.red[6] : theme.colors.red[6]}
                        size={theme.fontSizes.sm}
                    >
                        {stateArray[key]}
                    </Text>
                )
            })
        )
    }

    return (
        <React.Fragment>
            <PaperWrapper stateMB="2rem">
                <Text>Tambahan Jasa</Text>

                <Divider my='xs' />

                {Array.isArray(stateData.data) && (stateData.data.length > 0) && Object.keys(stateData.data).map((keyPS, indexPS) => {
                    return (
                        <Group
                            key={keyPS}

                            noWrap
                            mt='lg'
                            spacing='xs'
                            sx={(tema) => ({
                                alignItems: 'flex-start'
                            })}
                        >
                            <Text size='sm'>{Number(indexPS) + 1}.</Text>

                            <Box sx={{ width: '100%' }}>
                                <InputComponent
                                    stateId={`nama-jasa-${indexPS}`}
                                    stateWithAsterisk={false}
                                    stateLabel=''
                                    stateDescription=''
                                    statePlaceHolder='Nama Jasa'
                                    stateReadOnly={true}
                                    stateValue={stateData.data[keyPS].project_tambahan_jasa_nama}
                                    stateError=''

                                    stateStylesInput={{
                                        backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
                                    }}

                                    fnOnClick={() => {
                                        setData(d => ({
                                            ...d,
                                            jasaEdit: {
                                                ...d.jasaEdit,
                                                id: stateData.data[keyPS].project_tambahan_jasa_id,
                                                nama: stateData.data[keyPS].project_tambahan_jasa_nama,
                                                qty: stateData.data[keyPS].project_tambahan_jasa_jumlah,
                                                harga: stateData.data[keyPS].project_tambahan_jasa_harga_aktual,
                                                modalShow: true
                                            }
                                        }))
                                    }}

                                    fnOnChange={() => { }}
                                />

                                <Group noWrap spacing='xs' mt='.5rem'>
                                    <TextInput
                                        id={'harga-jasa' + indexPS}
                                        size="xs"
                                        variant='default'
                                        icon={
                                            <Text color="dimmed" size='sm'>
                                                {safeValue(stateData.data[keyPS].project_tambahan_jasa_jumlah, '')} x Rp
                                            </Text>
                                        }
                                        readOnly={true}
                                        placeholder='Harga Satuan'
                                        value={numberWithComma(safeValue(stateData.data[keyPS].project_tambahan_jasa_harga_aktual, ''))}

                                        onClick={() => {
                                            setData(d => ({
                                                ...d,
                                                jasaEdit: {
                                                    ...d.jasaEdit,
                                                    id: stateData.data[keyPS].project_tambahan_jasa_id,
                                                    nama: stateData.data[keyPS].project_tambahan_jasa_nama,
                                                    qty: stateData.data[keyPS].project_tambahan_jasa_jumlah,
                                                    harga: stateData.data[keyPS].project_tambahan_jasa_harga_aktual,
                                                    modalShow: true
                                                }
                                            }))
                                        }}

                                        sx={{
                                            width: `100% !important`
                                        }}

                                        styles={(tema) => ({
                                            input: {
                                                backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                                                paddingLeft: '4.5rem !important'
                                            },
                                            icon: {
                                                width: '4.5rem'
                                            }
                                        })}
                                    />
                                </Group>
                            </Box>

                            <ActionIconComponent
                                stateVariant='light'
                                stateRadius='xl'
                                stateTitle='Remove'
                                stateSize='sm'
                                StateIcon={IconTrash}
                                stateIconSize='1rem'
                                stateIconStrokeWidth={1.25}

                                fnOnClick={() => {
                                    setData(d => ({
                                        ...d,
                                        jasaDelete: {
                                            ...d.jasaDelete,
                                            id: stateData.data[keyPS].project_tambahan_jasa_id,
                                            nama: stateData.data[keyPS].project_tambahan_jasa_nama,
                                            modalShow: true
                                        }
                                    }))
                                }}
                            />
                        </Group>
                    )
                })}

                {Array.isArray(stateData.data) && (stateData.data.length <= 0) &&
                    <Text size='sm' color="dimmed">Tidak ada tambahan jasa.</Text>
                }

                <Group
                    spacing={5}
                    px='xs'
                    py='0.25rem'
                    mt='xl'
                    position="center"

                    sx={(tema) => ({
                        borderWidth: '1px',
                        borderStyle: 'dashed',
                        borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                        borderRadius: tema.radius.sm,
                        color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                        cursor: 'pointer',
                        '&:hover': {
                            backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
                        }
                    })}

                    onClick={() => setData(d => ({ ...d, jasa: { ...d.jasa, modalShow: true } }))}
                >
                    <IconPlus size='0.8rem' />
                    <Text size='sm'>Tambahan Jasa</Text>
                </Group>
            </PaperWrapper>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.jasa.modalShow}
                fnHide={() => setData(d => ({
                    ...d,
                    jasa: {
                        ...d.jasa,
                        modalShow: false
                    }
                }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Tambahan Jasa').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.jasa.submitLoading}
                fnButtonAction={submitDataTambahanJasa}
            >
                <InputComponent
                    stateId='itemPenggunaanTambahanJasaModal-1'
                    stateWithAsterisk={false}
                    stateLabel={<Text color="dimmed">Nama Jasa</Text>}
                    stateDescription=''
                    statePlaceHolder='Nama Jasa'
                    stateReadOnly={false}
                    stateValue={data.jasa.nama}
                    stateError=''

                    stateMT="sm"

                    fnOnChange={(e) => setData(d => ({
                        ...d, jasa: { ...d.jasa, nama: e.target.value }
                    }))}
                />

                <Group
                    noWrap

                    mt='md'
                >
                    <Box sx={{ width: '30%' }}>
                        <InputComponent
                            stateId='qtyPenggunaanTambahanJasaModal-1'
                            stateWithAsterisk={false}
                            stateLabel={<Text color="dimmed">Jumlah</Text>}
                            stateDescription=''
                            statePlaceHolder='Jumlah'
                            stateReadOnly={false}
                            stateValue={numberWithComma(data.jasa.qty)}
                            stateError=''

                            fnOnChange={(e) => setData(d => ({
                                ...d, jasa: { ...d.jasa, qty: regexNumberOnly(e.target.value) }
                            }))}
                        />
                    </Box>

                    <Box sx={{ width: '70%' }}>
                        <InputComponent
                            stateId='hargaPenggunaanTambahanJasaModal-1'
                            stateWithAsterisk={false}
                            stateLabel={<Text color="dimmed">Biaya</Text>}
                            stateDescription=''
                            statePlaceHolder='Biaya'
                            stateReadOnly={false}
                            stateValue={numberWithComma(data.jasa.harga)}
                            stateError=''
                            stateIcon={<Text size='sm' color="dimmed">Rp</Text>}

                            fnOnChange={(e) => setData(d => ({
                                ...d,
                                jasa: {
                                    ...d.jasa,
                                    harga: regexNumberOnly(e.target.value)
                                }
                            }))}
                        />
                    </Box>
                </Group>

                <Box mt='1rem'>
                    <AllErrorBox
                        stateArray={[
                            data.jasa.namaError,
                            data.jasa.qtyError,
                            data.jasa.hargaError,
                        ]}
                    />
                </Box>
            </ModalTakeAction>

            <ModalTakeAction
                stateShow={data.jasaEdit.modalShow}
                fnHide={() => setData(d => ({
                    ...d,
                    jasaEdit: {
                        ...d.jasaEdit,
                        modalShow: false
                    }
                }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Ubah Jasa').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.jasaEdit.submitLoading}
                fnButtonAction={submitDataTambahanJasaUpdate}
            >
                <InputComponent
                    stateId='itemPenggunaanTambahanJasaModalEdit-1'
                    stateWithAsterisk={false}
                    stateLabel={<Text color="dimmed">Nama Jasa</Text>}
                    stateDescription=''
                    statePlaceHolder='Nama Jasa'
                    stateReadOnly={false}
                    stateValue={data.jasaEdit.nama}
                    stateError=''

                    stateMT="sm"

                    fnOnChange={(e) => setData(d => ({
                        ...d, jasaEdit: { ...d.jasaEdit, nama: e.target.value }
                    }))}
                />

                <Group
                    noWrap
                    mt='md'
                >
                    <Box sx={{ width: '30%' }}>
                        <InputComponent
                            stateId='qtyPenggunaanTambahanJasaModalEdit-1'
                            stateWithAsterisk={false}
                            stateLabel={<Text color="dimmed">Jumlah</Text>}
                            stateDescription=''
                            statePlaceHolder='Jumlah'
                            stateReadOnly={false}
                            stateValue={numberWithComma(data.jasaEdit.qty)}
                            stateError=''

                            fnOnChange={(e) => setData(d => ({
                                ...d,
                                jasaEdit: {
                                    ...d.jasaEdit,
                                    qty: regexNumberOnly(e.target.value)
                                }
                            }))}
                        />
                    </Box>

                    <Box sx={{ width: '70%' }}>
                        <InputComponent
                            stateId='hargaPenggunaanTambahanJasaModalEdit-1'
                            stateWithAsterisk={false}
                            stateLabel={<Text color="dimmed">Biaya</Text>}
                            stateDescription=''
                            statePlaceHolder='Biaya'
                            stateReadOnly={false}
                            stateValue={numberWithComma(data.jasaEdit.harga)}
                            stateError=''
                            stateIcon={<Text size='sm' color="dimmed">Rp</Text>}

                            fnOnChange={(e) => setData(d => ({
                                ...d, jasaEdit: { ...d.jasaEdit, harga: regexNumberOnly(e.target.value) }
                            }))}
                        />
                    </Box>
                </Group>

                <Box mt='1rem'>
                    <AllErrorBox
                        stateArray={[
                            data.jasaEdit.namaError,
                            data.jasaEdit.qtyError,
                            data.jasaEdit.hargaError,
                        ]}
                    />
                </Box>
            </ModalTakeAction>

            <ModalTakeAction
                stateShow={data.jasaDelete.modalShow}
                fnHide={() => setData(d => ({
                    ...d,
                    jasaDelete: {
                        ...d.jasaDelete,
                        modalShow: false
                    }
                }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Delete Jasa').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.jasaDelete.submitLoading}
                fnButtonAction={submitDataTambahanJasaDelete}
            >
                <Text size='sm' color="dimmed">
                    Hapus Tambahan Jasa Ini ?
                </Text>
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default StepSelesaiTambahanJasa;